import request from '../../utils/request';

export const storeService = {
    //列表数据查询
    getStoreData: (data) => {
        return request({
            url: '/store/list',
            method: 'post',
            headers: {
                'Content-Type': 'application/json; charset=UTF-8'
            },
            data: data
        })
    }
}